/**
 * Constancia de aceptación de los términos. La pantalla de acceso dice «Al continuar
 * aceptas…»: al continuar se marca aquí y, con la sesión ya abierta, la app se lo informa
 * una vez a la API, que guarda la versión vigente y la fecha.
 */
const KEY = 'eco.terminos'

function safeStorage(): Storage | undefined {
  try {
    return globalThis.localStorage
  } catch {
    return undefined
  }
}

export function marcarTerminosAceptados(storage: Storage | undefined = safeStorage()): void {
  try {
    storage?.setItem(KEY, '1')
  } catch {
    /* sin almacenamiento: no queda constancia desde este navegador */
  }
}

export function terminosPendientes(storage: Storage | undefined = safeStorage()): boolean {
  try {
    return storage?.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function limpiarTerminos(storage: Storage | undefined = safeStorage()): void {
  try {
    storage?.removeItem(KEY)
  } catch {
    /* nada que limpiar */
  }
}
